<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="#003a6f"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="#004889">
            <v-card flat color="#004889">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="warrantyform">
                          <v-list-item class="form-row"> 
                              <v-list-item-content class="label">
                                  <v-list-item-title class="white--text font-weight-bold">Job</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Job" rules="required">
                                  <v-autocomplete
                                      v-model="form.job"
                                      :items="jobs"
                                      item-text="title"
                                      item-value="id"
                                      label="Job"
                                      :error-messages="errors"
                                      required
                                      solo
                                      flat
                                      dark
                                      return-object
                                  ></v-autocomplete>
                                  </ValidationProvider>
                              </v-list-item-action>
                          </v-list-item>
                          <v-list flat color="#004889" class="py-0">
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Issue</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <ValidationProvider v-slot="{ errors }" name="Issue" rules="required">
                                      <v-text-field
                                        v-model="form.issue"
                                        label="Issue"
                                        :error-messages="errors"
                                        required
                                        solo
                                        flat
                                        dark
                                      ></v-text-field>
                                    </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Description</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <ValidationProvider v-slot="{ errors }" name="Description" rules="required">
                                      <v-textarea
                                        v-model="form.description"
                                        :error-messages="errors"
                                        required
                                        solo
                                        flat
                                        dark
                                      ></v-textarea>
                                    </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Status</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                    <v-select
                                        v-model="form.status"
                                        :items="filteredStatuses"
                                        item-text="label"
                                        item-value="value"
                                        label="Status"
                                        required
                                        :error-messages="errors"
                                        solo
                                        flat
                                        dark
                                    ></v-select>
                                  </ValidationProvider>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Priority</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.priority"
                                        :items="priorities"
                                        item-text="label"
                                        item-value="value"
                                        required
                                        :error-messages="errors"
                                        solo
                                        flat
                                        dark
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Date Serviced</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-menu
                                        v-model="menu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                        <v-text-field
                                            v-model="computedDateServicedFormatted"
                                            readonly
                                            v-bind="attrs"
                                            v-on="on"
                                            solo
                                            flat
                                            dark
                                        ></v-text-field>
                                        </template>
                                        <v-date-picker
                                        v-model="form.date_serviced"
                                        @input="menu = false"
                                        ></v-date-picker>
                                    </v-menu>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Deadline</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                  <v-menu
                                      v-model="menu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="290px"
                                  >
                                      <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                          v-model="computedDeadlineFormatted"
                                          readonly
                                          v-bind="attrs"
                                          v-on="on"
                                          solo
                                          flat
                                          dark
                                          clearable
                                      ></v-text-field>
                                      </template>
                                      <v-date-picker
                                      v-model="form.deadline"
                                      @input="menu = false"
                                      ></v-date-picker>
                                  </v-menu>
                                </v-list-item-action>
                            </v-list-item>
                            <v-list-item class="form-row">
                                <v-list-item-content class="label">
                                    <v-list-item-title class="white--text font-weight-bold">Assignee</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-select
                                        v-model="form.assignee"
                                        :items="users"
                                        item-text="name"
                                        item-value="id"
                                        label="Assignee"
                                        clearable
                                        solo
                                        flat
                                        dark
                                        multiple
                                    ></v-select>
                                </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn large min-width="98%" color="white accent--text"  @click="submit" :loading="loading" tile>Create</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions> 
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { required } from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
    import axios from 'axios'
    import TokenService from '../../services/storage.service'
    import mixin from '../../mixin/main.js'
    import authmixin from '../../mixin/auth.js'

    setInteractionMode('eager')

    extend('required', {
        ...required,
        message: '{_field_} can not be empty',
    })

    export default {
        mixins: [mixin, authmixin],
        props: ['id'],
        data () {
            return {
                form: {
                    id: '',
                    issue: '',
                    status: 'active',
                    deadline: '',
                    assignee: [],
                    description: '',
                    date_serviced: new Date().toISOString().substr(0, 10),
                    priority: 'low',
                },
                search: null,
                isLoading: false,
                loading: false,
                token: '',
                pageTitle: '',
                issues: [],
                jobs: [],
            }
        },
        created() {
            this.token = TokenService.getToken()
            this.pageTitle = this.$route.meta.title
            this.getJobs()
        },
        components: {
            ValidationProvider,
            ValidationObserver,
        },
        computed: {
            ...mapGetters({
                statuses: 'data/jobStatusArray',
                priorities: 'data/priorities',
            }),
            filteredStatuses() {
                return this.statuses.filter(status => {
                    return status.value != 'all'
                })
            },
            computedDateServicedFormatted () {
                return this.formatDate(this.form.date_serviced)
            },
            computedDeadlineFormatted () {
                return this.formatDate(this.form.deadline)
            },
        },
        methods: {
            getJobs() {
                this.loading = true
                axios.get('crm/service/issue/jobs')
                    .then(response => {
                        this.loading = false
                        this.jobs = response.data
                        this.$nextTick()
                    })
            },
            async submit() {
                let valid1 = await this.$refs.observer1.validate()

                if(valid1) {
                    this.loading = true
                    this.$set(this.form, 'job', this.form.job.id)
                    axios.post('crm/service/issue/add', this.form).then(() => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'green')
                        this.$store.commit('SET_SNACK', 'Successfully saved!')
                        this.$router.push({ path: `/serviceissues` })
                    }).catch(error => {
                        this.loading = false
                        this.$store.commit('SET_SNACKTYPE', 'red')
                        if(error.response.data.error) {
                            this.$store.commit('SET_SNACK', error.response.data.error)
                        } else {
                            this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                        }
                    })
                } else {
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Please check your form for the errors.')
                }
            },
        }
    }
</script>

<style lang="sass">
.v-chip--select
    &.v-chip
        &.v-chip--clickable
            &.v-size--small
                background: #1976d2

.f-wrap
    width: 100%

    > span 
        min-width: calc(100% - 40px)

.label 
    .v-list-item__title
            white-space: inherit


.repeater
    background: #003a6f
</style>
